import { render, staticRenderFns } from "./NavBarV2.vue?vue&type=template&id=0dc88ee8"
import script from "./NavBarV2.vue?vue&type=script&lang=js"
export * from "./NavBarV2.vue?vue&type=script&lang=js"
import style0 from "./NavBarV2.vue?vue&type=style&index=0&id=0dc88ee8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports